import { Icon } from '@mui/material';
import { Box } from '@mui/system';
import NextImage from 'next/image';
import React, { useMemo } from 'react';
import {
  ImageContainer,
  IconContainer,
  Image,
  Title,
} from './BannerTitle.styles';
import { BannerTitlePropTypes, RoundedCornersType } from './BannerTitle.types';
import { DEFAUL_BORDER_CORNERS } from './defaultBorderCorners';

function FeaturedIcon({
  iconUrl,
  iconComponent,
}: Pick<BannerTitlePropTypes, 'iconUrl' | 'iconComponent'>): JSX.Element {
  if (iconUrl)
    return (
      <Icon style={{ position: 'relative' }}>
        <NextImage src={iconUrl} layout="fill" />
      </Icon>
    );
  if (iconComponent) return <>{iconComponent}</>;
  return null;
}
export function BannerTitle({
  title,
  iconUrl,
  image,
  roundedCorners,
  className,
  iconComponent,
}: BannerTitlePropTypes): JSX.Element {
  const { url } = image || {};
  const corners: RoundedCornersType = useMemo(
    () => ({
      ...DEFAUL_BORDER_CORNERS,
      ...roundedCorners,
    }),
    [roundedCorners],
  );

  return (
    <ImageContainer roundedCorners={corners} className={className}>
      <IconContainer zIndex={1}>
        <FeaturedIcon iconUrl={iconUrl} iconComponent={iconComponent} />
      </IconContainer>
      {url && (
        <Image
          layout="fill"
          sizes="100wv, 50vw"
          src={url}
          alt={title}
          objectFit="cover"
        />
      )}
      <Title color="common.white" variant="h1">
        {title}
      </Title>
    </ImageContainer>
  );
}

BannerTitle.defaultProps = {
  onIconClick: null,
  className: null,
};
